<app-genesys-editor
  class="gc-email-footer-editor"
  [editorSettings]="editorInitSetting"
  [placeholder]="'genesysEmailEditor.editorPlaceholder' | translate"
  (editorSetupDone)="onEditorSetupDone($event)"
  [(editorContent)]="htmlBody"
  [isUrlImagesEnabled]="true"
  (quoteButtonClick)="onAddQuotedContent()"
  [showQuoteButton]="showQuoteButton"
  (editorContentChange)="onEditorContentChange($event)"
>
</app-genesys-editor>
<app-genesys-email-attachments
  *ngIf="draftAttachments?.length"
  [attachments]="draftAttachments"
  [isEditable]="true"
  (deleteAction)="deleteFile($event)"
>
</app-genesys-email-attachments>
